import { render, staticRenderFns } from "./ContentHeading.vue?vue&type=template&id=90d10c3e&"
import script from "./ContentHeading.vue?vue&type=script&lang=js&"
export * from "./ContentHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports